import React, { useState, useEffect } from 'react';
import { Col, Typography, Row, Card, Button, Modal, Image, Layout } from 'antd';
import styled from 'styled-components';
import clip from 'src/sounds/clip-sound.mp3';
import clipGood from 'src/sounds/Good_job.mp3';
import clipTry from 'src/sounds/Try Again.mp3';
import 'react-simple-keyboard/build/css/index.css';
import useSound from 'use-sound';
import ReactPlayer from 'react-player';
import { StarOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import { ImgButton } from 'src/components/Header/toolHeaderstyle';
import { useHistory } from 'react-router-dom';
import FullScreenButton from 'src/components/common/FullScreenButton';
const { Header: HeaderWrapper } = Layout;
const { Title } = Typography;

const MainBlock = styled.div`
  padding: 10px;
  margin-top: 10px;
  background: #fff;
  height: calc(100vh - 94px);
`;

const TotalBox = styled.span`
  color: rgb(255, 122, 27);
  border: 1px solid #6b5c5c;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: ${(props) => props.isMobile && '14px'} !important;
`;

const ScoreBox = styled.span`
  color: #de3333;
  border: 1px solid #de3333ab;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: ${(props) => props.isMobile && '14px'} !important;
`;

const GrammarQuizPage = ({ onClickGoback, data = [], preset = '', dataUserStudy, handleSaveExit }) => {
  const [total, setTotal] = useState(data?.study_quiz_data.length);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(-1);
  const [complete, setComplete] = useState(0);
  const [stageType, setStageType] = useState(1);
  const [goBackIdx, setGoBackIdx] = useState(null);
  const [ans, setAns] = useState('');
  const [ques, setQues] = useState('');
  const [error, setError] = useState(-1);
  const [errorList, setErrorList] = useState([]);
  const [correct, setCorrect] = useState(-1);
  const [playing, setPlaying] = useState(false);
  const [nowSound, setNowSound] = useState(false);
  const [options, setOptions] = useState([]);
  const [answerSheet, setAnswerSheet] = useState([]);
  const history = useHistory();
  const [playGood] = useSound(clipGood, {
    onend: () => {
      setNowSound(false);
    },
  });
  useEffect(() => {
    if (
      dataUserStudy &&
      dataUserStudy.getUserStudyCompleteList &&
      dataUserStudy.getUserStudyCompleteList[0]?.user_study_answer?.length >= 0&&
      dataUserStudy.getUserStudyCompleteList[0]?.stat ===0
    ) {
      const lastStudyData = dataUserStudy.getUserStudyCompleteList[0]?.user_study_answer;
      const lastIdx = lastStudyData.findIndex((v) => v.user_answer === '');
      let tmpscore = 0;
      const tmp = data?.study_quiz_data?.map((e) => {
        let findAnswer = lastStudyData.find((a) => a.question_no === e.no);
        if (findAnswer && findAnswer.is_correct === '1') {
          tmpscore += (1 / total) * 100;
        }
        return {
          question_no: e.no,
          user_answer: findAnswer && findAnswer.user_answer !== '' ? findAnswer.user_answer : '',
          is_correct: findAnswer ? findAnswer.is_correct : '0',
        };
      });
      setScore(tmpscore);
      setAnswerSheet(tmp);
      setComplete(lastIdx === -1 ? 0 : lastIdx);
      setDone(lastIdx === -1 ? 0 : lastIdx);
    } else {
      const tmp = data?.study_quiz_data?.map((e) => {
        return {
          question_no: e.no,
          user_answer: '',
          is_correct: '0',
        };
      });
      setAnswerSheet(tmp);
    }
  }, [dataUserStudy, data]);
  useEffect(() => {
    if (done !== -1) {
      if (data && data?.study_quiz_data[done] && !nowSound) {
        setQues(data?.study_quiz_data[done].question);
        setAns(parseInt(data?.study_quiz_data[done].answer));
        setOptions(data?.study_quiz_data[done].option_list);
        setError(-1);
        setCorrect(-1);
        setPlaying(false);
      }
    }
  }, [done, data, stageType]);

  const handleAnswerClick = (val, i) => {
    if (error !== -1 || correct !== -1) return;
    if (i + 1 === ans) {
      setNowSound(true);
      playGood();
      setError(-1);
      setCorrect(i);
      let newscore = score;
      const tmp = [...answerSheet];
      tmp[done].user_answer = String(i + 1);
      tmp[done].is_correct = '1';
      setAnswerSheet(tmp);
      if (stageType != 3) {
        newscore += (1 / total) * 100;
        setScore(newscore);
      }
      goNext(newscore);
    } else {
      setCorrect(ans - 1);
      setError(i);
      const tmp = [...answerSheet];
      tmp[done].user_answer = String(i + 1);
      tmp[done].is_correct = '0';
      setAnswerSheet(tmp);
      errorList.push({ done, stageType });
      setErrorList(errorList);
      goNext();
    }
  };
  const goNext = (newscore = null) => {
    if (done < data?.study_quiz_data.length) {
      // setDone(done < data.length ? done + 1 : data.length);
      setComplete(complete + 1);
    } else {
      if (onClickGoback) {
        setTimeout(() => {
          const curScore = newscore ? Math.round(newscore) : Math.round(score);
          Modal.info({
            content: `Your total score is ${newscore ? Math.round(newscore) : Math.round(score)}`,
            onOk: () =>
              onClickGoback({
                exam_total: 100,
                exam_correct: curScore > 100 ? 100 : curScore,
                message: `Your total score is ${newscore ? Math.round(newscore) : Math.round(score)}`,
                user_answers: answerSheet,
              }),
          });
        }, 1000);
      }
    }
  };
  const goNextIndx = () => {
    if (complete === total) {
      if (onClickGoback) {
        const curScore = Math.round(score);

        Modal.info({
          content: `Your total score is ${Math.round(score)}`,
          onOk: () =>
            onClickGoback({
              exam_total: 100,
              exam_correct: curScore > 100 ? 100 : curScore,
              message: `Your total score is ${Math.round(score)}`,
              user_answers: answerSheet,
            }),
        });
      }
    } else if (done < data?.study_quiz_data.length - 1 && (done === -1 || complete > done)) {
      setDone(done + 1);
    }
  };
  const handleSwitchPassage = () => {
    if (goBackIdx === -1 || goBackIdx === null) {
      setDone(-1);
      setGoBackIdx(done);
    } else {
      setDone(goBackIdx);
      setGoBackIdx(-1);
    }
  };
  const handleCloseClick = () => {
    if (complete === total) {
      if (onClickGoback) {
        const curScore = Math.round(score);

        Modal.info({
          content: `Your total score is ${Math.round(score)}`,
          onOk: () =>
            onClickGoback({
              exam_total: 100,
              exam_correct: curScore > 100 ? 100 : curScore,
              message: `Your total score is ${Math.round(score)}`,
              user_answers: answerSheet,
            }),
        });
      }
    } else {
      Modal.confirm({
        icon: null,
        title: 'Exit',
        content: (
          <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
            학습이 완료되지 않았습니다. <br /> 종료하면 지금 학습하던 문제부터 <br />
            이어서 학습합니다. <br /> 종료 하시겠습니까?
          </Title>
        ),
        onOk: () => {
          handleSaveExit({ user_answers: answerSheet });
          history.push('/');
        },
      });
    }
  };
  return (
    <>
      <HeaderWrapper
        style={{
          background: '#fff',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%',
          height: isMobileOnly && 50,
          lineHeight: isMobileOnly && '50px',
        }}
      >
        <div style={{ paddingTop: 10 }}>
          <Title level={2} style={{ marginLeft: 20, textTransform: 'capitalize', fontSize: isMobileOnly && 20 }}>
            Reading Comprehension
          </Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileOnly && (
            <div style={{ backgroundColor: '' }}>
              <FullScreenButton
                element={<ImgButton className="header-btn" src="/images/fullscreen_blue.png" alt="back arrow in header" />}
                activeElement={<ImgButton className="header-btn" src="/images/fullscreenExit_blue.png" alt="back arrow in header" />}
              />
            </div>
          )}
          <div key="close" onClick={handleCloseClick}>
            <span style={{ color: '#999', cursor: 'pointer' }}>
              <CloseCircleOutlined
                style={{
                  marginRight: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#424242',
                }}
                key="close"
              />
            </span>
          </div>
        </div>
      </HeaderWrapper>
      <Col className="quiz-fluid-container" span={24} style={{ textAlign: 'left', margin: 0 }}>
        {done === -1 ? (
          <MainBlock className="quiz-fluid-scroll">
            <Row gutter={[24, 16]} style={{ padding: 10 }}>
              <Col className="quiz-heading" span={16}>
                <Row gutter={[24, 16]} style={{ margin: 0 }}>
                  <Col className="quiz-heading-containt" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                    <Title level={2} ellipsis>
                      <span style={{ color: '#065aa9', marginLeft: 10, fontSize: isMobileOnly && 16 }}>
                        Read the passage carefully and choose the correct answer.
                      </span>{' '}
                    </Title>
                  </Col>
                </Row>
              </Col>
              <Col
                className="quiz-heading-listing"
                span={8}
                style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 10 }}
              >
                {goBackIdx !== null ? (
                  <Button onClick={handleSwitchPassage} value="large">
                    Back
                  </Button>
                ) : (
                  <Button onClick={goNextIndx} type="primary" value="large">
                    Next
                  </Button>
                )}
              </Col>
            </Row>
            <Row gutter={[24, 16]} style={{ padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Col
                className={isMobileOnly ? 'word-board imagequizspeaker middle-box-mobile' : 'word-board imagequizspeaker'}
                span={16}
                style={{ padding: 10, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'flex-start' }}
              >
                <Card
                  style={{
                    width: '100%',
                    borderRadius: 20,
                    boxShadow: '10px 10px 5px 5px rgba(95, 77, 99, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  bodyStyle={{
                    background: '#fff',
                    borderRadius: 20,
                    minHeight: '300px',
                    display: 'flex',
                    cursor: 'default',
                    maxHeight: 'calc(100vh - 230px)',
                    justifyContent: 'center',
                  }}
                  hoverable
                  loading={false}
                >
                  <Image
                    height={'100%'}
                    src={
                      `https://cdn.cloubot.com/EVN/middle/${preset}/image/${data?.study_quiz_data[0]['question_image']}` ??
                      '/images/evine-logo.png'
                    }
                  />
                </Card>
              </Col>
            </Row>
          </MainBlock>
        ) : (
          <MainBlock className="quiz-fluid-scroll">
            <Row gutter={[24, 16]} style={{ padding: 10 }}>
              <Col className="quiz-heading" span={16}>
                <Row gutter={[24, 16]} style={{ margin: 0 }}>
                  <Col className="quiz-heading-containt" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                    <Title level={2} ellipsis>
                      <span style={{ color: '#065aa9', marginLeft: 10, fontSize: isMobileOnly && 16 }}>
                        Read the passage carefully and choose the correct answer.
                      </span>{' '}
                    </Title>
                  </Col>
                </Row>
              </Col>
              <Col
                className="quiz-heading-listing"
                span={8}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  paddingLeft: isMobileOnly && 0,
                  paddingRight: 10,
                }}
              >
                <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                  <ScoreBox isMobile={isMobileOnly}>Score : {Math.round(score)}</ScoreBox>{' '}
                </Title>
                <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                  <TotalBox isMobile={isMobileOnly}>
                    {done + 1} / {total}
                  </TotalBox>
                </Title>
                {complete <= done ? (
                  <Button onClick={handleSwitchPassage} value="large">
                    Text
                  </Button>
                ) : (
                  <Button disabled={complete <= done} onClick={goNextIndx} type="primary" value="large">
                    Next
                  </Button>
                )}
              </Col>
            </Row>
            <Row gutter={[24, 16]} style={{ padding: 10 }}>
              <Col
                className="word-board imagequizspeaker"
                span={10}
                style={{ padding: 10, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'flex-start' }}
              >
                <Card
                  style={{
                    width: '100%',
                    borderRadius: 20,
                    boxShadow: '10px 10px 5px 5px rgba(95, 77, 99, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    maxHeight: 'calc(100vh - 230px)',
                  }}
                  bodyStyle={{
                    background: '#fff',
                    borderRadius: 20,
                    minHeight: '300px',
                    maxHeight: 'calc(100vh - 230px)',
                    display: 'flex',
                    cursor: 'default',
                  }}
                  hoverable
                  loading={false}
                >
                  <Image
                    height={'100%'}
                    src={
                      `https://cdn.cloubot.com/EVN/middle/${preset}/image/${data?.study_quiz_data[0]['question_image']}` ??
                      '/images/evine-logo.png'
                    }
                  />
                </Card>
              </Col>
              <Col
                className={isMobileOnly ? 'word-board-option word-board-option-mobile' : 'word-board-option'}
                span={14}
                style={{
                  padding: '0 40px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                }}
              >
                <Title level={4} style={{ width: '100%', background: '#c0daf1', marginLeft: 10, padding: 10, borderRadius: 10 }}>
                  <span>
                    {error != -1 ? (
                      <StarOutlined
                        style={{ color: '#de3333', fontSize: '95px', position: 'absolute', marginTop: '-30px', marginLeft: '-30px' }}
                      />
                    ) : null}{' '}
                    {correct != -1 && error === -1 ? (
                      <svg
                        height="95"
                        width="95"
                        style={{ color: '#4dde33', fontSize: '95px', position: 'absolute', marginTop: '-30px', marginLeft: '-30px' }}
                      >
                        <circle cx="50" cy="50" r="40" stroke="#4dde33" strokeWidth="10" fill="transparent" />
                      </svg>
                    ) : null}{' '}
                    {stageType === 3 ? '다시 풀기:' : `Q${done + 1}. `}
                  </span>
                  &nbsp;
                  <span dangerouslySetInnerHTML={{ __html: ques }}></span>
                </Title>

                {options.map((v, i) => (
                  <Title
                    key={i}
                    level={4}
                    style={{
                      width: 'calc(100% - 20px)',
                      border: `3px solid #${error === i ? 'de3333' : correct === i ? '4dde33' : 'c0daf1'}`,
                      marginLeft: 30,
                      padding: 10,
                      borderRadius: 10,
                      cursor: 'pointer',
                    }}
                    onClick={() => handleAnswerClick(v, i)}
                  >{`${i + 1}. ${v}`}</Title>
                ))}
              </Col>
            </Row>
          </MainBlock>
        )}
      </Col>
    </>
  );
};

export default GrammarQuizPage;
